import type { TTourFiltersPageState, TTourFiltersState } from '@/entities/filter/store/types/tour/state';
import type { MindboxSearchCustomFields } from '@/pages/listing/lib/mindbox/shared/types';
import {
  mapArrayToLabels,
  mapRubrics,
  mapSorting,
  mapTourFormatTypes,
  mindboxTourNumberOfPeople,
  toMindboxDate,
  toNumber,
} from '@/pages/listing/lib/mindbox/shared/helpers';

export type TourMindboxSearchPayloadParams = {
  searchState: TTourFiltersState;
  pageParams: TTourFiltersPageState;
  cityName: string;
  countryName?: string;
  movementTypeLabels?: Record<string, string | undefined> | null;
  formatLabels?: Record<string, string | undefined> | null;
  durationLabels?: Record<string, string | undefined> | null;
  startTimeLabels?: Record<string, string | undefined> | null;
  sortingLabels?: Record<string, string | undefined> | null;
  comfortLabels?: Record<string, string | undefined> | null;
  accommodationLabels?: Record<string, string | undefined> | null;
  activityLevelLabels?: Record<string, string | undefined> | null;
};

/** Payload турового листинга для Mindbox (отдельно от экскурсионного searchState). */
export const buildTourMindboxSearchPayload = (params: TourMindboxSearchPayloadParams): MindboxSearchCustomFields => {
  const {
    searchState,
    cityName,
    countryName,
    formatLabels,
    sortingLabels,
    comfortLabels,
    accommodationLabels,
    activityLevelLabels,
  } = params;
  const [priceMin, priceMax] = searchState.price;

  return {
    searchType: 'tour',
    searchCityName: cityName ?? '',
    searchCountryName: countryName ?? '',
    searchDateFrom: toMindboxDate(searchState.date.from),
    searchDateTo: toMindboxDate(searchState.date.to),
    searchPriceMin: toNumber(priceMin),
    searchPriceMax: toNumber(priceMax),
    searchWithKids: searchState.childrenAllowed === true,
    searchNumberOfPeople: mindboxTourNumberOfPeople(searchState),
    searchMovementType: [],
    searchDuration: [],
    searchFormat: mapTourFormatTypes(searchState, formatLabels),
    searchRubrics: mapRubrics(searchState.tag__slugs),
    searchStartTime: [],
    searchSortBy: mapSorting(searchState.sorting, sortingLabels),
    searchComfort: mapArrayToLabels(searchState.comfort_type, comfortLabels),
    searchAccommodationType: mapArrayToLabels(searchState.accommodation_type, accommodationLabels),
    searchActivityLevel: mapArrayToLabels(searchState.activity_level_category, activityLevelLabels),
  };
};
